<template>
  <div class="messages">
    <messages-header :filter="filter" @change="onChange" class="mb-2" />
    <messages-list :messages="computedMessages" :type="type" :loading="loading" @seen="$emit('seen', $event)" />
  </div>
</template>

<script>
import MessagesHeader from './MessagesHeader.vue'
import MessagesList from './MessagesList.vue'
import { messagesQuery } from '@/helpers/helpers'

export default {
  name: 'Messages',

  props: {
    type: {
      type: String
    },

    messages: {
      type: Array
    },

    loading: {
      type: Boolean
    }
  },

  watch: {
    type(value) {
      this.filter.type = value
    }
  },

  computed: {
    computedMessages() {
      return messagesQuery(this.messages, this.filter.query, this.filter.dateDir)
    }
  },

  data() {
    return {
      filter: {
        query: '',
        type: this.type,
        dateDir: 'desc'
      }
    }
  },

  methods: {
    onChange({ filter, prop }) {
      this.filter = filter
      if (prop === 'type') {
        this.$emit('change', filter.type)
      }
    }
  },

  components: {
    MessagesHeader,
    MessagesList
  }
}
</script>
